<script setup lang="ts">
import SiteNav from './SiteNav.vue';
import SiteFooter from './SiteFooter.vue';
import { onMounted } from 'vue';
import { installSiteAttribution } from './siteAttribution';

// Client-only (onMounted never runs during SSG): remember the landing utm_source and
// hand it to the bot's start= on "via Telegram" / card links. No SSR output changes.
onMounted(installSiteAttribution);
</script>

<template>
  <!-- overflow-x CLIP, not hidden: `hidden` forces overflow-y to auto, which made
       this root SiteNav's sticky scroll container (it never stuck, and landing
       sections' scroll-mt-20 had nothing to clear). `hidden` stays only as the
       fallback where `overflow: clip` is unsupported (iOS Safari < 16). -->
  <div class="paper-grain min-h-dvh overflow-x-hidden supports-[overflow:clip]:overflow-x-clip bg-background text-foreground scroll-smooth">
    <SiteNav />
    <main>
      <slot />
    </main>
    <SiteFooter />
  </div>
</template>
